import { ReportHandler } from 'web-vitals';

// Sends a single Core Web Vital metric to Google Analytics 4
const sendToGA4 = ({ name, delta, id }: { name: string; delta: number; id: string }) => {
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', name, {
    event_category: 'Web Vitals',
    event_label: id,
    value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    non_interaction: true,
  });
};

const reportWebVitals = (onPerfEntry?: ReportHandler) => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

// Auto-report Web Vitals to GA4 in production
if (process.env.NODE_ENV === 'production') {
  import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
    getCLS(sendToGA4);
    getFID(sendToGA4);
    getFCP(sendToGA4);
    getLCP(sendToGA4);
    getTTFB(sendToGA4);
  });
}

// Augment Window type to include gtag
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export default reportWebVitals;
